/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { toast } from 'react-toastify';

import { all, takeLatest, call, put } from 'redux-saga/effects';

import api from '~/services/api';
import history from '~/services/history';

import {
  createImportProcessFailure,
  createImportProcessSuccess,
  getLatestImportProcessFailure,
  getLatestImportProcessSuccess,
} from './actions';
import {
  ICreateImportProcessRequestAction,
  IGetLatestImportProcessRequestAction,
  IImportProcessTypes,
} from './types';

function* createImportProcess({
  payload,
}: ICreateImportProcessRequestAction): any {
  const {
    referenceId,
    type,
    operation,
    fileName,
    createdById,
    successPushUrl,
  } = payload;

  try {
    yield call(api.post, '/import-process', {
      referenceId,
      type,
      operation,
      fileName,
      createdById,
    });

    yield put(createImportProcessSuccess());
    if (successPushUrl) {
      history.push(successPushUrl);
    }
    toast.success('Solicitação concluída com sucesso');
  } catch (err) {
    yield put(createImportProcessFailure());
    toast.error(err.response.data.message);
  }
}

function* getLatestImportProcess({
  payload,
}: IGetLatestImportProcessRequestAction): any {
  const { referenceId } = payload;

  try {
    const { data: importProcess } = yield call(
      api.get,
      `/import-process/${referenceId}/reference-id`,
    );

    yield put(getLatestImportProcessSuccess(importProcess));
  } catch (err) {
    yield put(getLatestImportProcessFailure());
  }
}

export default all([
  takeLatest(
    IImportProcessTypes.CREATE_IMPORT_PROCESS_REQUEST,
    createImportProcess,
  ),
  takeLatest(
    IImportProcessTypes.GET_LATEST_IMPORT_PROCESS_REQUEST,
    getLatestImportProcess,
  ),
]);
